<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1400px] mx-auto pb-10">

    <!-- Header -->
    <div class="flex items-center justify-between gap-4 mb-6 flex-wrap">
      <div class="flex items-center gap-4 min-w-0">
        <button class="h-10 w-10 rounded-full bg-white border border-gray-200 hover:border-amber-300 hover:bg-amber-50 text-gray-500 hover:text-amber-700 flex items-center justify-center shadow-sm transition-colors flex-shrink-0"
          (click)="back()" [matTooltip]="source === 'shipments' ? 'Back to shipments' : 'Back to incoming stocks'" aria-label="Back">
          <mat-icon class="!text-[20px]">arrow_back</mat-icon>
        </button>
        <div class="min-w-0">
          <div class="flex items-center gap-1.5 text-xs text-gray-400 font-medium">
            <button class="hover:text-amber-700 transition-colors" (click)="back()">{{ source === 'shipments' ? 'Shipments' : 'Incoming Stocks' }}</button>
            @if (card) {
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">chevron_right</mat-icon>
            <a class="hover:text-amber-700 transition-colors" [routerLink]="['/shipments/edit', card.shipmentId]">{{ card.shipmentReference }}</a>
            }
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">chevron_right</mat-icon>
            <span class="text-gray-500">Container</span>
          </div>
          <div class="flex items-center gap-2.5 flex-wrap">
            <h1 class="text-2xl font-bold text-gray-900 tracking-tight font-mono truncate">{{ card?.containerNo || (loading ? '…' : 'Container') }}</h1>
            @if (card) {
            @if (canChangeState) {
            @if (status !== 'DELIVERED') {
            <button type="button" class="ctr-mic relative h-8 w-8 rounded-full flex items-center justify-center transition-all"
              [ngClass]="listening ? 'bg-red-500 text-white is-listening' : 'bg-violet-50 text-violet-600 hover:bg-violet-100'"
              [disabled]="saving" (click)="speakState()" [matTooltip]="listening ? 'Listening - say a state, e.g. “cleared”' : 'Say its new state'" aria-label="Say the new state">
              <mat-icon class="!text-[17px] !h-[17px] !w-[17px] relative z-10">{{ listening ? 'graphic_eq' : 'mic' }}</mat-icon>
            </button>
            }
            <button type="button" class="inline-flex items-center gap-0.5 rounded-full pl-2.5 pr-1.5 py-0.5 text-[11px] font-semibold capitalize hover:shadow-sm transition-shadow"
              [ngClass]="getStatusClass(status)" [matMenuTriggerFor]="stateMenu" [disabled]="saving" matTooltip="Change state">
              {{ status | lowercase }}<mat-icon class="!text-[14px] !h-3.5 !w-3.5 opacity-60">expand_more</mat-icon>
            </button>
            <mat-menu #stateMenu="matMenu">
              @for (st of stateOptions; track st.value) {
              <button mat-menu-item (click)="setState(st.value)" [disabled]="st.value === status">{{ st.label }}</button>
              }
            </mat-menu>
            } @else {
            <span class="rounded-full px-2.5 py-0.5 text-[11px] font-semibold capitalize" [ngClass]="getStatusClass(status)">{{ status | lowercase }}</span>
            }
            }
          </div>
        </div>
      </div>
      @if (card && status === 'DELIVERED' && source === 'shipments') {
      <a class="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-fuchsia-600 text-white text-sm font-semibold shadow-md shadow-fuchsia-200 hover:bg-fuchsia-700 transition-colors"
        [routerLink]="['/delivery-validation/receipts/container', card.id]" matTooltip="For the delivery team">
        <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">fact_check</mat-icon> Check in at Incoming Stocks
      </a>
      }
    </div>

    @if (loading) {
    <div class="bg-white rounded-2xl border border-gray-100 shadow-sm min-h-80 flex flex-col justify-center items-center">
      <mat-spinner diameter="32"></mat-spinner>
      <div class="text-sm text-gray-500 mt-3">Loading container&hellip;</div>
    </div>
    } @else if (!card) {
    <div class="bg-white rounded-2xl border border-gray-100 shadow-sm min-h-80 flex flex-col justify-center items-center text-center px-6">
      <span class="h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center mb-3"><mat-icon class="!text-[28px] !h-7 !w-7">search_off</mat-icon></span>
      <div class="text-lg font-semibold text-gray-800">Container not found</div>
      <div class="text-sm text-gray-500 mt-1 max-w-md">It may have been removed from its shipment.</div>
      <button class="mt-4 px-5 py-2.5 rounded-xl bg-neutral-900 text-white text-sm font-semibold hover:bg-neutral-700" (click)="back()">Go back</button>
    </div>
    } @else {

    <!-- Where it is -->
    <div class="mb-6 flex items-center gap-3 rounded-2xl border px-4 py-3 text-sm"
      [ngClass]="status === 'RECEIVED' ? 'bg-emerald-50 border-emerald-200 text-emerald-900' : status === 'CANCELLED' ? 'bg-red-50 border-red-200 text-red-800' : status === 'DELIVERED' ? 'bg-fuchsia-50 border-fuchsia-200 text-fuchsia-900' : 'bg-white border-gray-200 text-gray-700'">
      <mat-icon class="!text-[20px] !h-5 !w-5 flex-shrink-0">{{ status === 'RECEIVED' ? 'inventory' : status === 'DELIVERED' ? 'warehouse' : status === 'CANCELLED' ? 'block' : 'directions_boat' }}</mat-icon>
      <span class="font-semibold">{{ stateNote }}</span>
      @if (card.clearedAt) { <span class="ml-auto text-xs font-semibold text-violet-700 flex items-center gap-1"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">verified</mat-icon>Cleared {{ card.clearedAt | date: 'd MMM yyyy' }}</span> }
    </div>

    <!-- Where it came from -->
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <a class="group rounded-2xl bg-neutral-900 text-white p-5 shadow-sm hover:-translate-y-0.5 transition-transform" [routerLink]="['/shipments/edit', card.shipmentId]">
        <div class="text-[11px] font-semibold uppercase tracking-wider text-neutral-400">Shipment</div>
        <div class="text-2xl font-bold mt-1">{{ card.shipmentReference }}</div>
        <div class="text-xs text-neutral-400 mt-1 flex items-center gap-1 group-hover:text-amber-300 transition-colors">Open shipment <mat-icon class="!text-[14px] !h-3.5 !w-3.5">arrow_forward</mat-icon></div>
      </a>
      <div class="rounded-2xl bg-white border border-gray-100 p-5 shadow-sm min-w-0">
        <div class="text-[11px] font-semibold uppercase tracking-wider text-gray-400">Carrier</div>
        <div class="text-base font-bold text-gray-900 mt-1 truncate">{{ card.shippingLine || '-' }}</div>
        <div class="text-xs text-gray-400 mt-1 truncate">{{ card.vesselDetails || 'No vessel details' }}</div>
      </div>
      <div class="rounded-2xl bg-white border border-gray-100 p-5 shadow-sm min-w-0">
        <div class="text-[11px] font-semibold uppercase tracking-wider text-gray-400">Voyage</div>
        <div class="text-base font-bold text-gray-900 mt-1 truncate">{{ card.portOfLoading || '?' }} &rarr; {{ card.portOfDischarge || '?' }}</div>
        <div class="text-xs text-gray-400 mt-1">ETD {{ card.etd ? (card.etd | date: 'd MMM') : '-' }} &middot; ETA {{ card.eta ? (card.eta | date: 'd MMM yyyy') : '-' }}</div>
      </div>
      <div class="rounded-2xl bg-white border border-gray-100 p-5 shadow-sm min-w-0">
        <div class="text-[11px] font-semibold uppercase tracking-wider text-gray-400">Into stock at</div>
        <div class="text-base font-bold text-gray-900 mt-1 flex items-center gap-1.5"><mat-icon class="!text-[18px] !h-[18px] !w-[18px] text-amber-600">warehouse</mat-icon>{{ card.store }}</div>
        <div class="text-xs text-gray-400 mt-1">{{ units }} unit{{ units === 1 ? '' : 's' }} &middot; {{ card.lines.length }} line{{ card.lines.length === 1 ? '' : 's' }}</div>
      </div>
    </div>

    <!-- Purchase orders it carries -->
    <div class="flex items-center gap-2 flex-wrap mb-4">
      <span class="text-xs font-semibold text-gray-400 uppercase tracking-wider mr-1">Purchase orders</span>
      @for (o of orders; track o.reference) {
      <a class="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-lg bg-amber-50 text-amber-800 border border-amber-100 hover:bg-amber-100 transition-colors"
        [routerLink]="['/purchases/edit', o.purchaseOrderId]" [matTooltip]="o.supplierName || 'Open purchase order'">
        <mat-icon class="!text-[14px] !h-3.5 !w-3.5">receipt_long</mat-icon>{{ o.reference }}
        @if (o.supplierName) { <span class="font-normal text-amber-700/70">{{ o.supplierName }}</span> }
      </a>
      }
    </div>

    @if (canCheckIn) {
    <!-- Check-in form -->
    <app-container-receipt-card [card]="card" [linkToDetail]="false" (received)="back()" />
    } @else {
    <!-- What's in it (read-only) -->
    <div class="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
      <div class="px-5 py-4 border-b border-gray-100 flex items-center gap-2">
        <mat-icon class="!text-[18px] !h-[18px] !w-[18px] text-gray-400">inventory_2</mat-icon>
        <div class="font-bold text-gray-900">What's in it</div>
      </div>
      <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left text-xs font-semibold text-gray-400 uppercase tracking-wide bg-gray-50/60">
            <th class="px-5 py-2.5">Product</th>
            <th class="px-3 py-2.5">Purchase order</th>
            <th class="px-5 py-2.5 text-right">Quantity</th>
          </tr>
        </thead>
        <tbody>
          @for (l of card.lines; track l.id) {
          <tr class="border-t border-gray-50">
            <td class="px-5 py-3">
              <div class="font-medium text-gray-900">{{ l.productName }}</div>
              @if (l.sku) { <a class="text-xs text-gray-400 font-mono hover:text-amber-700 hover:underline" [routerLink]="['/inventory']" [queryParams]="{ q: l.sku }" target="_blank" rel="noopener">{{ l.sku }}</a> }
            </td>
            <td class="px-3 py-3">
              <a class="text-xs font-semibold text-gray-700 hover:text-amber-700 hover:underline" [routerLink]="['/purchases/edit', l.purchaseOrderId]">{{ l.poReference }}</a>
              @if (l.outstandingOnPo !== null) { <div class="text-[11px] text-gray-400">{{ l.outstandingOnPo }} still outstanding on the PO</div> }
            </td>
            <td class="px-5 py-3 text-right font-semibold text-gray-900">{{ l.expected }} <span class="text-[11px] font-normal text-gray-400">{{ l.unitOfMeasure }}</span></td>
          </tr>
          } @empty {
          <tr><td colspan="3" class="px-5 py-8 text-center text-gray-400">Nothing in this container yet</td></tr>
          }
        </tbody>
      </table>
      </div>
    </div>
    }

    <!-- Sent back to the supplier -->
    @if (card.returns?.length) {
    <div class="mt-6 bg-white rounded-2xl border border-sky-100 shadow-sm overflow-hidden">
      <div class="px-5 py-4 border-b border-sky-100 bg-sky-50/50 flex items-center gap-2">
        <mat-icon class="!text-[18px] !h-[18px] !w-[18px] text-sky-600">assignment_return</mat-icon>
        <div class="font-bold text-gray-900">Returned to the supplier</div>
        <span class="text-xs text-sky-800 font-semibold ml-1">{{ returnedUnits }} unit{{ returnedUnits === 1 ? '' : 's' }} &middot; still outstanding on the PO</span>
      </div>
      @for (r of card.returns!; track $index) {
      <div class="px-5 py-3 border-t border-gray-50 first:border-t-0 flex items-baseline gap-3 text-sm">
        <div class="min-w-0 flex-1">
          <div class="font-medium text-gray-900">{{ r.productName }}</div>
          <div class="text-xs text-gray-400"><span class="font-mono">{{ r.sku || '-' }}</span>@if (r.reason) { &middot; {{ r.reason }} } &middot; {{ r.createdAt | date: 'd MMM yyyy' }}</div>
        </div>
        <span class="font-semibold text-sky-800">{{ r.quantity }}</span>
      </div>
      }
    </div>
    }
    }

  </div>
  </div>
</app-main-layout>
